import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-nav-bar',
  imports: [],
  templateUrl: './nav-bar.component.html',
  standalone: true,
  styleUrl: './nav-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavBarComponent {}
